<template>
    <router-link to="/tryout-groups" tag="li"
        ><a
            ><i class="fa fa-pencil"></i><span>Tryout Group</span></a
        ></router-link
    >
</template>

<script>
export default {
    name: "itembank-nav",

    components: {},

    data: function () {
        return { items: [] };
    },

    mounted: function () {},
};
</script>



// WEBPACK FOOTER //
// Navigation.vue?2c9681b6